// src/contexts/CustomerContext.js
import React, { createContext, useState } from 'react';

// Create the context
const CustomerContext = createContext();

export const CustomerProvider = ({ children }) => {
    const [customerInfo, setCustomerInfo] = useState(null);

    return (
        <CustomerContext.Provider value={{ customerInfo, setCustomerInfo }}>
            {children}
        </CustomerContext.Provider>
    );
};

export default CustomerContext;
